import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField } from "components/support";

const Items = ({ item }) => (
  <Row>
    <Col xs={6}>
      <DescriptionField label="Produto" value={item.name} />
    </Col>
    <Col xs={6}>
      <DescriptionField label="Quantidade" value={item.quantity} />
    </Col>
  </Row>
);

export default Items;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/info/kit-info/items/index.jsx